<div class="w100 h100">
  <div
    [hidden]="dataIsEmpty && noDataMessage"
    [id]="tabulatorContainerId"
    [class]="classList"
    [class.expand-table]="tableExpanded"
  ></div>
  <span *ngIf="dataIsEmpty && noDataMessage" class="empty-table-message">{{ noDataMessage }}</span>
</div>

<div [id]="tabulatorContainerForDownloadId" [style.display]="'none'"></div>
